


















import { Component, Vue, Prop } from 'vue-property-decorator'

import AdFoxBannerReloader from '~/components/frequentPatterns/advertising/AdFoxBannerReloader.vue'

@Component({
  inheritAttrs: false,
  components: { AdFoxBannerReloader }
})
export default class MainContentWithAd extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  disabled: boolean
}
